<template>
    <CustomerBase
        :customer="props.customer"
        :contract="props.contract"
    >
        <DCard
            padding
        >
            <SuspensionForm
                ref="createForm"
                :errors="props.errors"
                :contract="props.contract"
                :customer="props.customer"
                :suspension-subject-type="props.suspensionSubjectType"
                @submit="sendEmailOrSms"
            />
        </DCard>
    </CustomerBase>
</template>

<script setup>
import CustomerBase from '~@/Pages/Customers/Base'

import SuspensionForm from '~@/Components/Customers/Contracts/Suspension/Form'
import { route } from '~@/Composables/route'

const props = defineProps({
    errors: {
        type: Object,
        default: () => { return {} }
    },
    customer: {
        type: Object,
        default: () => { return {} }
    },
    contract: {
        type: Object,
        default: () => { return {} }
    },
    suspensionSubjectType: {
        type: Array,
        default: () => { return [] }
    }
})

const sendEmailOrSms = (form) => {
    form.post(route('customers.customers.contracts.send-suspension-notification', {
        customer: props.customer.id,
        contract: props.contract.id
    }))
}

</script>
